(function () {
  var CLIP_SHIFT = '23%';
  var CLIP_TRANSITION_MS = 800;
  var MODAL_OPEN_DELAY_MS = 400;
  var MODAL_BG_MOBILE_MAX = 767;
  var KLAVIYO_FORM_ID_A = 'TRQLQk';
  var KLAVIYO_FORM_ID_B = 'TeFM5r';
  var MOCK_PRIZE_STORAGE_KEY = 'sm2026-lottery-mock-prize-index';

  function parseConfig(root) {
    try {
      return JSON.parse(root.getAttribute('data-config') || '{}');
    } catch (error) {
      console.error('Invalid lottery config:', error);
      return {};
    }
  }

  function parseJson(root, selector) {
    var el = root.querySelector(selector);

    if (!el) {
      var scope = root.closest('.section-2026-sydney-marathon-lottery-wrapper') || root.parentElement;
      if (scope) {
        el = scope.querySelector(selector);
      }
    }

    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('Invalid lottery JSON config:', selector, error);
      return null;
    }
  }

  function normalizeFormId(id) {
    return String(id || '').replace(/-/g, '').toUpperCase();
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function isMobileViewport() {
    return window.innerWidth <= MODAL_BG_MOBILE_MAX;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function SydneyMarathon2026Plinko(root, config) {
    this.root = root;
    this.config = config || {};
    this.refreshTargets();
    this.isAnimating = false;
    this.resetBall();
  }

  SydneyMarathon2026Plinko.prototype.refreshTargets = function () {
    var variant = this.root.getAttribute('data-ab-variant');
    var inlineBoard = this.root.querySelector('[data-sm2026-plinko-board-inline]');
    var modalBoard = this.root.querySelector('.sydney-marathon-2026-lottery__modal--signup [data-sm2026-plinko-board]:not([data-sm2026-plinko-board-inline])');
    var activeBoard = variant === 'A' && inlineBoard ? inlineBoard : modalBoard;

    this.board = activeBoard || inlineBoard || modalBoard || this.root.querySelector('[data-sm2026-plinko-board]');
    this.ball = this.board ? this.board.querySelector('[data-sm2026-plinko-ball]') : null;
  };

  SydneyMarathon2026Plinko.prototype.getBallFill = function () {
    if (this.board) {
      var boardFill = this.board.getAttribute('data-ball-fill');
      if (boardFill) {
        return boardFill;
      }
    }

    var variant = this.root.getAttribute('data-ab-variant');
    if (variant === 'A' && this.config.ballFillA) {
      return this.config.ballFillA;
    }

    return this.config.ballFill;
  };

  SydneyMarathon2026Plinko.prototype.getStartPoint = function () {
    var variant = this.root.getAttribute('data-ab-variant');

    if (variant === 'A' && this.config.startA) {
      return this.config.startA;
    }

    return this.config.start;
  };

  SydneyMarathon2026Plinko.prototype.getCxOffset = function () {
    var variant = this.root.getAttribute('data-ab-variant');

    if (variant === 'A' && this.config.cxOffsetA != null) {
      return this.config.cxOffsetA;
    }

    return 0;
  };

  SydneyMarathon2026Plinko.prototype.getEndY = function () {
    var variant = this.root.getAttribute('data-ab-variant');

    if (variant === 'A' && this.config.endYA != null) {
      return this.config.endYA;
    }

    return this.config.endY;
  };

  SydneyMarathon2026Plinko.prototype.resetBall = function () {
    var start = this.getStartPoint();
    var cxOffset = this.getCxOffset();
    if (!this.ball || !start) return;

    this.ball.setAttribute('cx', start.x + cxOffset);
    this.ball.setAttribute('cy', start.y);
    this.ball.setAttribute('r', this.config.ballRadius || 20);

    var ballFill = this.getBallFill();
    if (ballFill) {
      this.ball.setAttribute('fill', ballFill);
    }
  };

  SydneyMarathon2026Plinko.prototype.buildDynamicPath = function (index) {
    var config = this.config;
    var start = this.getStartPoint();

    if (!start || !this.board) {
      return null;
    }
    var points = [];
    var laneIndex = Math.max(0, Math.min(3, index));
    var laneXs = (config.lanes && config.lanes[laneIndex]) || [];
    var rowYs = config.rowYs || [];
    var cxOffset = this.getCxOffset();
    var i;

    points.push({ x: start.x + cxOffset, y: start.y });

    for (i = 0; i < rowYs.length; i++) {
      points.push({ x: laneXs[i] + cxOffset, y: rowYs[i] });
    }

    points.push({
      x: ((config.prizeCentersX && config.prizeCentersX[laneIndex]) || start.x) + cxOffset,
      y: this.getEndY(),
    });

    var d = 'M ' + points[0].x + ' ' + points[0].y;
    for (i = 1; i < points.length; i++) {
      d += ' L ' + points[i].x + ' ' + points[i].y;
    }

    var pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pathEl.setAttribute('d', d);
    pathEl.setAttribute('fill', 'none');
    pathEl.setAttribute('stroke', 'none');
    this.board.appendChild(pathEl);
    return pathEl;
  };

  SydneyMarathon2026Plinko.prototype.animateAlongPath = function (pathEl, durationMs) {
    var self = this;
    var totalLen = pathEl.getTotalLength();

    if (!totalLen || !this.ball) {
      return Promise.resolve();
    }
    var startPoint = pathEl.getPointAtLength(0);

    this.ball.setAttribute('cx', startPoint.x);
    this.ball.setAttribute('cy', startPoint.y);

    return new Promise(function (resolve) {
      var startTime = performance.now();

      function frame(now) {
        var raw = Math.min(1, (now - startTime) / durationMs);
        var t = easeInOutCubic(raw);
        var pt = pathEl.getPointAtLength(t * totalLen);

        self.ball.setAttribute('cx', pt.x);
        self.ball.setAttribute('cy', pt.y);

        if (raw < 1) {
          requestAnimationFrame(frame);
          return;
        }

        resolve();
      }

      requestAnimationFrame(frame);
    });
  };

  SydneyMarathon2026Plinko.prototype.play = function (prizeIndex) {
    var self = this;

    if (!this.board || !this.ball || this.isAnimating) {
      return Promise.resolve();
    }

    this.isAnimating = true;
    this.resetBall();

    var pathEl = this.buildDynamicPath(prizeIndex);
    var durationMs = this.config.durationMs || 2600;

    if (!pathEl) {
      this.isAnimating = false;
      return Promise.resolve();
    }

    return this.animateAlongPath(pathEl, durationMs).finally(function () {
      pathEl.remove();
      self.isAnimating = false;
    });
  };

  function SydneyMarathon2026Lottery(root) {
    this.root = root;
    this.config = parseConfig(root);
    this.plinkoConfig = parseJson(root, '.sm2026-lottery-plinko-config') || {};
    this.modalCopy = parseJson(root, '.sm2026-lottery-modal-prizes-config') || [];
    this.heroCopy = parseJson(root, '.sm2026-lottery-hero-prizes-config') || [];
    this.modalBgConfig = parseJson(root, '.sm2026-lottery-modal-prizes-bg-config') || { pc: [], mb: [] };
    this.modalBgPreloadCache = new Map();
    this.lastPrizeIndex = 0;
    this.lastDrawData = null;
    this.mockPrizeIndex = this.getStoredMockPrizeIndex();
    this.isDrawing = false;

    this.signupModal = root.querySelector('.sydney-marathon-2026-lottery__modal--signup');
    this.resultModal = root.querySelector('.sydney-marathon-2026-lottery__modal--result');
    this.resultDialog = root.querySelector('.sydney-marathon-2026-lottery__modal-dialog--result');
    this.resultTitle = root.querySelector('.sydney-marathon-2026-lottery__result-title');
    this.resultText = root.querySelector('.sydney-marathon-2026-lottery__result-text');
    this.resultCta = root.querySelector('.sydney-marathon-2026-lottery__result-cta');
    this.resultVisualWrap = root.querySelector('[data-result-visual-wrap]');
    this.resultVisualImg = root.querySelector('[data-result-visual]');
    this.resultVisualPc = root.querySelector('[data-result-visual-pc]');
    this.resultVisualMb = root.querySelector('[data-result-visual-mb]');
    this.resultNotice = root.querySelector('.sydney-marathon-2026-lottery__result-notice');
    this.signupNoticeA = root.querySelector('[data-signup-notice="a"]');
    this.signupNoticeB = root.querySelector('[data-signup-notice="b"]');
    this.signupNotice = this.signupNoticeB;
    this.signupFormWrap = root.querySelector('.sydney-marathon-2026-lottery__signup-form-wrap');
    this.plinkoGame = root.querySelector('.sydney-marathon-2026-lottery__plinko-game');
    this.plinkoGames = root.querySelectorAll('.sydney-marathon-2026-lottery__plinko-game');
    this.plinko = new SydneyMarathon2026Plinko(root, this.plinkoConfig);
    this.viewResultBtn = root.querySelector('[data-view-result]');
    this.openSignupBtn = root.querySelector('button[data-open-signup-modal]');
    this.openSignupTriggers = root.querySelectorAll('[data-open-signup-modal]');
    this.heroSignupTrigger = root.querySelector('.sydney-marathon-2026-lottery__hero-picture[data-open-signup-modal]');
    this.heroCopyEl = root.querySelector('.sydney-marathon-2026-lottery__hero-copy');
    this.heroDefault = root.querySelector('[data-hero-default]');
    this.heroResult = root.querySelector('[data-hero-result]');
    this.heroResultIcon = root.querySelector('[data-hero-result-icon]');
    this.heroResultTitle = root.querySelector('[data-hero-result-title]');
    this.heroResultText = root.querySelector('[data-hero-result-text]');
    this.heroResultCta = root.querySelector('[data-hero-result-cta]');
    this.progressNote = root.querySelector('[data-lottery-progress-note]');
    this.signupTitle = root.querySelector('.sydney-marathon-2026-lottery__signup-title');
    this.abVariant = root.getAttribute('data-ab-variant') || '';

    this.bindEvents();
    this.initBackgroundPreload();
    this.initImpressionTracking();
    this.initAbTest();
  }

  SydneyMarathon2026Lottery.prototype.getClipImages = function () {
    return Array.from(this.root.querySelectorAll('.sydney-marathon-2026-lottery__clip-image'));
  };

  SydneyMarathon2026Lottery.prototype.getVisibleClipImages = function () {
    return this.getClipImages().filter(function (el) {
      return el.offsetParent !== null;
    });
  };

  SydneyMarathon2026Lottery.prototype.animateClipDown = function (clipImage) {
    var self = this;

    return new Promise(function (resolve) {
      var transitionDone = false;
      var minTimeDone = false;

      function finish() {
        clipImage.removeEventListener('transitionend', onEnd);
        window.clearTimeout(minDurationTimer);
        window.clearTimeout(fallbackTimer);
        resolve();
      }

      function tryFinish() {
        if (transitionDone && minTimeDone) finish();
      }

      function onEnd(e) {
        if (e.target !== clipImage || e.propertyName !== 'transform') return;
        transitionDone = true;
        tryFinish();
      }

      var minDurationTimer = window.setTimeout(function () {
        minTimeDone = true;
        tryFinish();
      }, CLIP_TRANSITION_MS);

      var fallbackTimer = window.setTimeout(function () {
        transitionDone = true;
        minTimeDone = true;
        tryFinish();
      }, CLIP_TRANSITION_MS + 200);

      clipImage.addEventListener('transitionend', onEnd);
      clipImage.style.transition = 'none';
      clipImage.style.transform = 'translateY(0)';
      void clipImage.offsetHeight;

      window.requestAnimationFrame(function () {
        clipImage.style.removeProperty('transition');
        clipImage.style.transform = 'translateY(' + CLIP_SHIFT + ')';
      });
    });
  };

  SydneyMarathon2026Lottery.prototype.pullClipDown = function () {
    var clipImages = this.getVisibleClipImages();
    if (!clipImages.length) return Promise.resolve();

    return Promise.all(clipImages.map(this.animateClipDown.bind(this)));
  };

  SydneyMarathon2026Lottery.prototype.restoreClipUp = function () {
    this.getClipImages().forEach(function (clipImage) {
      clipImage.style.removeProperty('transition');
      clipImage.style.transform = 'translateY(0)';
    });
  };

  SydneyMarathon2026Lottery.prototype.getActiveModalBgUrls = function () {
    return isMobileViewport() ? this.modalBgConfig.mb : this.modalBgConfig.pc;
  };

  SydneyMarathon2026Lottery.prototype.preloadModalBackground = function (url) {
    if (!url) return Promise.resolve();
    if (this.modalBgPreloadCache.has(url)) return this.modalBgPreloadCache.get(url);

    var promise = new Promise(function (resolve) {
      var img = new Image();

      function done() {
        if (typeof img.decode === 'function') {
          img.decode().then(resolve).catch(resolve);
          return;
        }
        resolve();
      }

      img.onload = done;
      img.onerror = done;
      img.src = url;
    });

    this.modalBgPreloadCache.set(url, promise);
    return promise;
  };

  SydneyMarathon2026Lottery.prototype.preloadAllModalBackgrounds = function (priorityIndex) {
    var urls = this.getActiveModalBgUrls().filter(Boolean);
    var self = this;

    if (priorityIndex != null && urls[priorityIndex]) {
      this.preloadModalBackground(urls[priorityIndex]);
    }

    urls.forEach(function (url, index) {
      if (index !== priorityIndex) self.preloadModalBackground(url);
    });
  };

  SydneyMarathon2026Lottery.prototype.ensureModalBackgroundReady = function (prizeIndex) {
    var urls = this.getActiveModalBgUrls();
    return this.preloadModalBackground(urls[prizeIndex]);
  };

  SydneyMarathon2026Lottery.prototype.initBackgroundPreload = function () {
    var self = this;

    var runPreload = function () {
      self.preloadAllModalBackgrounds();

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () {
          [].concat(self.modalBgConfig.pc, self.modalBgConfig.mb)
            .filter(Boolean)
            .forEach(function (url) {
              self.preloadModalBackground(url);
            });
        }, { timeout: 2000 });
      }
    };

    if (!('IntersectionObserver' in window)) {
      runPreload();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runPreload();
        observer.disconnect();
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    observer.observe(this.root);
  };

  SydneyMarathon2026Lottery.prototype.openModal = function (modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  SydneyMarathon2026Lottery.prototype.closeModal = function (modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (
      !this.signupModal.classList.contains('is-open') &&
      !this.resultModal.classList.contains('is-open')
    ) {
      document.body.style.overflow = '';
    }
  };

  SydneyMarathon2026Lottery.prototype.closeAllModals = function () {
    this.closeModal(this.signupModal);
    this.closeModal(this.resultModal);
    this.restoreClipUp();
  };

  SydneyMarathon2026Lottery.prototype.shouldUseHeroInlineResult = function () {
    return this.abVariant === 'A';
  };

  SydneyMarathon2026Lottery.prototype.getResultCtaHref = function (copy) {
    var fallback = this.config.resultCtaHref || '#sydney-marathon-season-sale';

    if (!copy.buttonLabel) {
      return '';
    }

    return copy.buttonLink || fallback;
  };

  SydneyMarathon2026Lottery.prototype.updateHeroResult = function (prizeIndex) {
    var copy = this.modalCopy[prizeIndex] || {};

    this.lastPrizeIndex = prizeIndex;

    if (this.heroResult) {
      this.heroResult.setAttribute('data-prize-index', String(prizeIndex));
    }

    if (this.heroResultIcon) {
      var isNoPrize = prizeIndex === 3;

      this.heroResultIcon.hidden = !isNoPrize;
      this.heroResultIcon.setAttribute('aria-hidden', isNoPrize ? 'false' : 'true');
    }

    if (this.heroResultTitle) {
      var heroTitle = (this.heroCopy[prizeIndex] && this.heroCopy[prizeIndex].title) || copy.title || '';

      this.heroResultTitle.innerHTML = heroTitle;
    }

    if (this.heroResultText) {
      this.heroResultText.innerHTML = copy.text || '';
      this.heroResultText.hidden = !copy.text;
    }

    if (this.heroResultCta) {
      var href = this.getResultCtaHref(copy);

      if (copy.buttonLabel && href) {
        this.heroResultCta.textContent = copy.buttonLabel;
        this.heroResultCta.href = href;
        this.heroResultCta.hidden = false;
      } else {
        this.heroResultCta.hidden = true;
      }
    }
  };

  SydneyMarathon2026Lottery.prototype.setProgressNoteVisible = function (isVisible) {
    if (!this.progressNote) return;
    this.progressNote.hidden = !isVisible;
  };

  SydneyMarathon2026Lottery.prototype.showHeroInlineResult = function (prizeIndex) {
    this.setProgressNoteVisible(false);
    this.updateHeroResult(prizeIndex);

    if (this.heroDefault) {
      this.heroDefault.hidden = true;
    }

    if (this.heroResult) {
      this.heroResult.hidden = false;
    }

    if (this.heroCopyEl) {
      this.heroCopyEl.classList.add('is-result-shown');
    }

    this.setHeroCompletedState(true);
  };

  SydneyMarathon2026Lottery.prototype.showResult = function (prizeIndex) {
    if (this.shouldUseHeroInlineResult()) {
      this.showHeroInlineResult(prizeIndex);
      return;
    }

    this.showResultModal(prizeIndex);
  };

  SydneyMarathon2026Lottery.prototype.updateResultModal = function (prizeIndex) {
    var copy = this.modalCopy[prizeIndex] || {};
    var pcUrls = this.modalBgConfig.pc || [];
    var mbUrls = this.modalBgConfig.mb || [];
    var pcUrl = pcUrls[prizeIndex] || '';
    var mbUrl = mbUrls[prizeIndex] || pcUrl;
    var activeUrl = isMobileViewport() ? mbUrl : pcUrl;

    this.lastPrizeIndex = prizeIndex;

    if (this.resultDialog) {
      this.resultDialog.setAttribute('data-prize-index', String(prizeIndex));
      this.resultDialog.style.backgroundImage = '';
    }

    if (this.resultVisualPc) {
      this.resultVisualPc.srcset = pcUrl || '';
    }

    if (this.resultVisualMb) {
      this.resultVisualMb.srcset = mbUrl || '';
    }

    if (this.resultVisualImg) {
      this.resultVisualImg.src = activeUrl || '';
      this.resultVisualImg.alt = this.getResultVisualAlt(copy.title);
    }

    if (this.resultVisualWrap) {
      this.resultVisualWrap.hidden = !pcUrl && !mbUrl;
    }

    if (this.resultTitle) {
      this.resultTitle.innerHTML = copy.title || '';
    }

    if (this.resultText) {
      this.resultText.innerHTML = copy.text || '';
      this.resultText.hidden = !copy.text;
    }

    if (this.resultCta) {
      var href = this.getResultCtaHref(copy);

      if (copy.buttonLabel && href) {
        this.resultCta.textContent = copy.buttonLabel;
        this.resultCta.href = href;
        this.resultCta.hidden = false;
      } else {
        this.resultCta.hidden = true;
      }
    }
  };

  SydneyMarathon2026Lottery.prototype.getResultVisualAlt = function (titleHtml) {
    if (!titleHtml) return 'Prize result';

    var temp = document.createElement('div');
    temp.innerHTML = titleHtml;
    var text = (temp.textContent || temp.innerText || '').replace(/\s+/g, ' ').trim();
    return text || 'Prize result';
  };

  SydneyMarathon2026Lottery.prototype.showResultModal = function (prizeIndex) {
    this.setProgressNoteVisible(false);
    this.updateResultModal(prizeIndex);
    this.openModal(this.resultModal);
    this.setHeroCompletedState(true);
  };

  SydneyMarathon2026Lottery.prototype.setHeroCompletedState = function (isCompleted) {
    if (this.openSignupBtn) {
      this.openSignupBtn.hidden = isCompleted;
    }

    if (this.viewResultBtn) {
      this.viewResultBtn.hidden = !isCompleted || this.shouldUseHeroInlineResult();
    }

    var heroCtaWrap = this.root.querySelector('.sydney-marathon-2026-lottery__hero-cta-wrap');
    if (heroCtaWrap) {
      heroCtaWrap.hidden = isCompleted;
    }

    var inlineForm = this.root.querySelector('.sydney-marathon-2026-lottery__hero-inline-form');
    if (inlineForm && this.abVariant === 'A') {
      inlineForm.hidden = isCompleted;
    }

    if (this.heroSignupTrigger) {
      this.heroSignupTrigger.classList.toggle('is-signup-disabled', isCompleted);
      this.heroSignupTrigger.setAttribute('aria-disabled', isCompleted ? 'true' : 'false');
    }
  };

  SydneyMarathon2026Lottery.prototype.runSignupPlinko = function (prizeIndex) {
    if (this.plinko.refreshTargets) {
      this.plinko.refreshTargets();
    }

    if (this.abVariant !== 'A') {
      this.openModal(this.signupModal);
    }

    this.plinko.isAnimating = false;
    this.setProgressNoteVisible(true);
    return this.plinko.play(prizeIndex);
  };

  SydneyMarathon2026Lottery.prototype.shakeSignupForm = function () {
    var wrap = this.abVariant === 'A'
      ? this.root.querySelector('.sydney-marathon-2026-lottery__hero-inline-form')
      : this.signupFormWrap;

    if (!wrap) return;

    wrap.classList.remove('is-shaking');
    void wrap.offsetWidth;
    wrap.classList.add('is-shaking');

    window.setTimeout(function () {
      wrap.classList.remove('is-shaking');
    }, 400);
  };

  SydneyMarathon2026Lottery.prototype.startLottery = function (prizeIndex) {
    var self = this;

    this.preloadAllModalBackgrounds(prizeIndex);

    return this.pullClipDown().then(function () {
      return Promise.all([
        delay(MODAL_OPEN_DELAY_MS),
        self.ensureModalBackgroundReady(prizeIndex),
      ]);
    }).then(function () {
      self.showResultModal(prizeIndex);
    });
  };

  SydneyMarathon2026Lottery.prototype.getPrizeIndex = function (actPriceId) {
    var ids = this.config.prizePriceIds || [];
    var normalized = String(actPriceId);
    var index = ids.indexOf(normalized);
    return index >= 0 ? index : null;
  };

  SydneyMarathon2026Lottery.prototype.getStoredMockPrizeIndex = function () {
    if (!this.config.useMockDraw) return 0;

    try {
      var stored = window.sessionStorage.getItem(MOCK_PRIZE_STORAGE_KEY);
      if (stored == null) return 0;

      var parsed = parseInt(stored, 10);
      return Number.isNaN(parsed) ? 0 : ((parsed % 4) + 4) % 4;
    } catch (error) {
      return 0;
    }
  };

  SydneyMarathon2026Lottery.prototype.storeMockPrizeIndex = function (index) {
    try {
      window.sessionStorage.setItem(MOCK_PRIZE_STORAGE_KEY, String(index));
    } catch (error) {
      /* ignore storage failures */
    }
  };

  SydneyMarathon2026Lottery.prototype.getForcedMockPrizeIndex = function () {
    if (!this.config.useMockDraw) return null;

    var params = new URLSearchParams(window.location.search);
    var forced = params.get('lottery_prize');

    if (forced == null) return null;

    var index = parseInt(forced, 10);
    if (Number.isNaN(index) || index < 0 || index > 3) return null;

    return index;
  };

  SydneyMarathon2026Lottery.prototype.getNextMockPrizeIndex = function () {
    var forcedIndex = this.getForcedMockPrizeIndex();
    if (forcedIndex != null) return forcedIndex;

    var index = this.mockPrizeIndex;
    this.mockPrizeIndex = (this.mockPrizeIndex + 1) % 4;
    this.storeMockPrizeIndex(this.mockPrizeIndex);
    return index;
  };

  SydneyMarathon2026Lottery.prototype.runWinFlow = function (prizeIndex, drawData) {
    var self = this;

    this.lastPrizeIndex = prizeIndex;
    this.lastDrawData = drawData || { mock: true, prizeIndex: prizeIndex };
    this.hideNotice(this.signupNotice);
    this.hideNotice(this.resultNotice);
    this.preloadAllModalBackgrounds(prizeIndex);

    return this.runSignupPlinko(prizeIndex).then(function () {
      return self.ensureModalBackgroundReady(prizeIndex);
    }).then(function () {
      self.closeModal(self.signupModal);
      self.showResult(prizeIndex);
    });
  };

  SydneyMarathon2026Lottery.prototype.draw = function (email) {
    var formData = new FormData();
    formData.append('mb_id', email);
    formData.append('act_id', this.config.lotteryActId || '');

    if (this.config.usageScenarios) {
      formData.append('usage_scenarios', this.config.usageScenarios);
    }

    return fetch('https://global.shokz.com/lottery/openapi_prize.php', {
      method: 'POST',
      body: formData,
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HTTP error ' + response.status);
      }
      return response.json();
    });
  };

  SydneyMarathon2026Lottery.prototype.normalizeActStatus = function (actStatus) {
    return String(actStatus || '').trim().toLowerCase().replace(/\s+/g, '_');
  };

  SydneyMarathon2026Lottery.prototype.getActStatusMessage = function (actStatus) {
    var normalized = this.normalizeActStatus(actStatus);

    if (normalized === 'no_login') {
      return 'An unexpected error occurred. Please try again later.';
    }

    if (normalized === 'no_act') {
      return 'This campaign is currently unavailable. Please try again later.';
    }

    if (normalized === 'no_finish') {
      return 'Emails exceeded the limit for participation';
    }

    if (normalized === 'no_finish_ip') {
      return 'The number of requests from the same IP address exceeded the limit.';
    }

    return 'An unexpected error occurred. Please try again later.';
  };

  SydneyMarathon2026Lottery.prototype.showNotice = function (target, message) {
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  };

  SydneyMarathon2026Lottery.prototype.hideNotice = function (target) {
    if (!target) return;
    target.hidden = true;
    target.textContent = '';
  };

  SydneyMarathon2026Lottery.prototype.getSubscribeContentName = function () {
    return this.abVariant === 'A' ? 'A_signup' : 'B_signup';
  };

  SydneyMarathon2026Lottery.prototype.trackSubscribe = function (email, status) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'subscribe',
      event_parameters: {
        module: 'sydney_marathon_subscription',
        status: status,
        email: email || '',
        content_name: this.getSubscribeContentName(),
      },
    });
  };

  SydneyMarathon2026Lottery.prototype.getNoPrizeIndex = function () {
    var ids = this.config.prizePriceIds || [];
    return ids.length > 0 ? ids.length - 1 : 3;
  };

  SydneyMarathon2026Lottery.prototype.isNoPrizeResult = function (drawResult) {
    if (!drawResult || !drawResult.data) return false;

    if (this.normalizeActStatus(drawResult.data.act_status) === 'no_prize') {
      return true;
    }

    return this.getPrizeIndex(drawResult.data.act_price_id) === this.getNoPrizeIndex();
  };

  SydneyMarathon2026Lottery.prototype.handleDrawResult = function (drawResult, email) {
    email = email || this.lastSubscribeEmail || '';

    if (!drawResult) {
      this.trackSubscribe(email, 'fail');
      this.showNotice(this.signupNotice, 'An unexpected error occurred. Please try again later.');
      return Promise.resolve();
    }

    if (this.isNoPrizeResult(drawResult)) {
      this.trackSubscribe(email, 'success');
      return this.runWinFlow(this.getNoPrizeIndex(), drawResult.data);
    }

    if (drawResult.status === 'error' || !drawResult.data) {
      this.trackSubscribe(email, 'fail');
      this.showNotice(
        this.signupNotice,
        this.getActStatusMessage(drawResult.data && drawResult.data.act_status)
      );
      return Promise.resolve();
    }

    if (drawResult.status !== 'ok') {
      this.trackSubscribe(email, 'fail');
      this.showNotice(this.signupNotice, 'An unexpected error occurred. Please try again later.');
      return Promise.resolve();
    }

    var prizeIndex = this.getPrizeIndex(drawResult.data.act_price_id);

    if (prizeIndex !== null) {
      this.trackSubscribe(email, 'success');
      return this.runWinFlow(prizeIndex, drawResult.data);
    }

    this.trackSubscribe(email, 'fail');
    this.showNotice(
      this.signupNotice,
      this.getActStatusMessage(drawResult.data.act_status)
    );

    return Promise.resolve();
  };

  SydneyMarathon2026Lottery.prototype.handleKlaviyoSubmit = function (email) {
    var self = this;

    if (this.isDrawing) return;
    if (!this.config.useMockDraw && !email) return;

    this.isDrawing = true;
    this.lastSubscribeEmail = email || '';
    this.hideNotice(this.signupNotice);
    this.hideNotice(this.resultNotice);

    if (this.config.useMockDraw) {
      this.runWinFlow(this.getNextMockPrizeIndex())
        .then(function () {
          self.trackSubscribe(email, 'success');
        })
        .finally(function () {
          self.isDrawing = false;
        });
      return;
    }

    this.draw(email)
      .then(function (result) {
        return self.handleDrawResult(result, email);
      })
      .catch(function (error) {
        console.error('Lottery draw request failed:', error);
        self.trackSubscribe(email, 'fail');
        self.showNotice(self.signupNotice, 'An unexpected error occurred. Please try again later.');
      })
      .finally(function () {
        self.isDrawing = false;
      });

    // VWO conversion goal — only fires when the VWO SmartCode (account 1049185) is active.
    if (window.VWO && typeof window.VWO.event === 'function') {
      try {
        window.VWO.event('sm2026_lottery_signup', { variant: self.abVariant || '' });
      } catch (err) {
        /* ignore VWO event failures */
      }
    }
  };

  SydneyMarathon2026Lottery.prototype.getKlaviyoFormIds = function () {
    return {
      a: this.config.klaviyoFormIdA || KLAVIYO_FORM_ID_A,
      b: this.config.klaviyoFormIdB || KLAVIYO_FORM_ID_B,
    };
  };

  SydneyMarathon2026Lottery.prototype.isLotteryKlaviyoForm = function (formId) {
    var ids = this.getKlaviyoFormIds();

    return (
      normalizeFormId(formId) === normalizeFormId(ids.a) ||
      normalizeFormId(formId) === normalizeFormId(ids.b)
    );
  };

  SydneyMarathon2026Lottery.prototype.getSignupButtonName = function () {
    return this.openSignupBtn ? this.openSignupBtn.textContent.trim() : '';
  };

  SydneyMarathon2026Lottery.prototype.handleOpenSignupModal = function () {
    this.hideNotice(this.signupNotice);
    this.plinko.resetBall();
    this.openModal(this.signupModal);

    var titleEl = this.root.querySelector('.sydney-marathon-2026-lottery__title');
    var contentName = titleEl ? titleEl.textContent.trim() : '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: 'subscribe_draw',
        content_name: contentName,
        button_name: this.getSignupButtonName(),
      },
    });
  };

  SydneyMarathon2026Lottery.prototype.bindSignupModalTriggers = function () {
    var self = this;

    if (!this.openSignupTriggers || !this.openSignupTriggers.length) return;

    this.openSignupTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (trigger.classList.contains('is-signup-disabled')) return;
        self.handleOpenSignupModal();
      });

      if (trigger.getAttribute('role') === 'button') {
        trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (trigger.classList.contains('is-signup-disabled')) return;
          self.handleOpenSignupModal();
        });
      }
    });
  };

  SydneyMarathon2026Lottery.prototype.bindEvents = function () {
    var self = this;

    this.bindSignupModalTriggers();

    if (this.plinkoGames && this.plinkoGames.length) {
      this.plinkoGames.forEach(function (game) {
        game.addEventListener('click', function () {
          self.shakeSignupForm();
        });
      });
    }

    if (this.viewResultBtn) {
      this.viewResultBtn.addEventListener('click', function () {
        if (self.shouldUseHeroInlineResult()) {
          self.showHeroInlineResult(self.lastPrizeIndex);
        } else {
          self.showResultModal(self.lastPrizeIndex);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'select_content',
          event_parameters: {
            content_type: 'subscribe_draw',
            content_name: '',
            button_name: 'view_result',
          },
        });
      });
    }

    this.root.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = el.closest('.sydney-marathon-2026-lottery__modal');
        self.closeModal(modal);

        if (modal && modal.classList.contains('sydney-marathon-2026-lottery__modal--result')) {
          self.restoreClipUp();
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (self.resultModal.classList.contains('is-open')) {
        self.closeModal(self.resultModal);
        self.restoreClipUp();
      } else if (self.signupModal.classList.contains('is-open')) {
        self.closeModal(self.signupModal);
      }
    });

    if (this.resultCta) {
      this.resultCta.addEventListener('click', function (event) {
        self.handleResultCtaClick(event, this.getAttribute('href'));
      });
    }

    if (this.heroResultCta) {
      this.heroResultCta.addEventListener('click', function (event) {
        self.handleResultCtaClick(event, this.getAttribute('href'));
      });
    }

    window.addEventListener('klaviyoForms', function (event) {
      var detail = event.detail || {};

      if (!self.isLotteryKlaviyoForm(detail.formId)) {
        return;
      }

      if (detail.type === 'open') {
        self.preloadAllModalBackgrounds();
      }

      if (detail.type === 'submit') {
        var email = (detail.metaData && detail.metaData.$email) || '';
        self.handleKlaviyoSubmit(email);
      }
    });
  };

  SydneyMarathon2026Lottery.prototype.handleResultCtaClick = function (event, href) {
    if (!href || href.charAt(0) !== '#') return;

    event.preventDefault();
    this.closeAllModals();

    var target = document.querySelector(href);
    var siteHeader = document.querySelector('.site-header');
    var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;

    if (target) {
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 60;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    }
  };

  SydneyMarathon2026Lottery.prototype.initImpressionTracking = function () {
    if (!('IntersectionObserver' in window)) return;

    var tracked = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (tracked || !entry.isIntersecting) return;

        var rect = entry.boundingClientRect;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var isBottomInViewport = rect.bottom > 0 && rect.bottom <= viewportHeight;
        if (!isBottomInViewport) return;

        tracked = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'module_impression',
          event_parameters: {
            module: 'subscribe_draw',
          },
        });
        observer.disconnect();
      });
    }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });

    observer.observe(this.root);
  };

  SydneyMarathon2026Lottery.prototype.applyAbVariantUI = function (variant) {
    var panelsA = this.root.querySelectorAll('[data-ab-panel="a"]');
    var panelsB = this.root.querySelectorAll('[data-ab-panel="b"]');

    panelsA.forEach(function (panel) {
      panel.hidden = variant !== 'A';
    });

    panelsB.forEach(function (panel) {
      panel.hidden = variant !== 'B';
    });

    this.signupNotice = variant === 'A' ? this.signupNoticeA : this.signupNoticeB;

    if (this.signupTitle) {
      this.signupTitle.hidden = variant === 'A';
    }

    if (this.plinko && this.plinko.refreshTargets) {
      this.plinko.refreshTargets();
    }
  };

  SydneyMarathon2026Lottery.prototype.isVariantAPanelVisible = function () {
    var panel = this.root.querySelector('[data-ab-panel="a"]');

    if (!panel) {
      return false;
    }

    return !panel.hidden && panel.offsetParent !== null;
  };

  SydneyMarathon2026Lottery.prototype.getPreviewAbVariantFromUrl = function () {
    if (!this.config.abPreviewEnabled) {
      return '';
    }

    var paramName = this.config.abPreviewParam || 'sm2026_lottery_ab';

    try {
      var value = new URLSearchParams(window.location.search).get(paramName);
      if (!value) return '';

      var normalized = String(value).trim().toUpperCase();
      if (normalized === 'A' || normalized === 'B') {
        return normalized;
      }
    } catch (error) {
      /* ignore */
    }

    return '';
  };

  SydneyMarathon2026Lottery.prototype.getStoredAbVariant = function () {
    var storageKey = 'sm2026_ab_variant';

    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored === 'A' || stored === 'B') {
        return stored;
      }

      var variant = Math.random() < 0.5 ? 'A' : 'B';
      window.sessionStorage.setItem(storageKey, variant);
      return variant;
    } catch (error) {
      return Math.random() < 0.5 ? 'A' : 'B';
    }
  };

  SydneyMarathon2026Lottery.prototype.initAbTest = function () {
    var self = this;
    var root = this.root;
    var previewVariant = this.getPreviewAbVariantFromUrl();
    var fired = false;

    var fire = function (variant) {
      if (fired) return;
      fired = true;
      root.setAttribute('data-ab-variant', variant);
      self.abVariant = variant;
      self.applyAbVariantUI(variant);
      self.fireAbImpression(variant);
      self.applyAbVariantToGtag(variant);
    };

    if (previewVariant) {
      try {
        window.sessionStorage.setItem('sm2026_ab_variant', previewVariant);
      } catch (error) {
        /* ignore */
      }

      fire(previewVariant);
      return;
    }

    if (!this.config.abTestEnabled) {
      return;
    }

    var useVwo = !!this.config.abUseVwoControl;

    if (useVwo) {
      var resolved = false;
      var resolve = function () {
        if (resolved) return;
        resolved = true;
        fire(self.isVariantAPanelVisible() ? 'A' : 'B');
      };

      window.addEventListener('vwoExperimentRun', resolve, { once: true });
      window.setTimeout(resolve, 1500);
      return;
    }

    fire(this.getStoredAbVariant());
  };

  SydneyMarathon2026Lottery.prototype.fireAbImpression = function (variant) {
    var eventName = variant === 'A'
      ? (this.config.abEventNameA || 'abtest_260803_au_pre_sub_all_A')
      : (this.config.abEventNameB || 'abtest_260803_au_pre_sub_all_B');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: {
        experiment: 'sm2026_sydney_marathon_email_signup_ab',
        variant: variant
      },
    });
  };

  SydneyMarathon2026Lottery.prototype.applyAbVariantToGtag = function (variant) {
    this.abVariant = variant;
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('set', { experiment_variant: variant });
      } catch (e) {
        /* ignore */
      }
    }
  };

  function initLottery(root) {
    if (!root || root.dataset.lotteryInitialized === 'true') return;
    root.dataset.lotteryInitialized = 'true';
    new SydneyMarathon2026Lottery(root);
  }

  function boot() {
    document.querySelectorAll('sydney-marathon-2026-lottery').forEach(initLottery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('sydney-marathon-2026-lottery');
    if (root) initLottery(root);
  });

  if (!customElements.get('sydney-marathon-2026-lottery')) {
    customElements.define('sydney-marathon-2026-lottery', class SydneyMarathon2026LotteryElement extends HTMLElement {});
  }
})();
